import { render } from "./SingleDuration.vue?vue&type=template&id=5f5e6d1d&scoped=true"
import script from "./SingleDuration.vue?vue&type=script&lang=js"
export * from "./SingleDuration.vue?vue&type=script&lang=js"

import "./SingleDuration.vue?vue&type=style&index=0&id=5f5e6d1d&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5e6d1d"]])

export default __exports__